/*
 * @Author: randy
 * @Date: 2020-08-01 14:01:52
 * @LastEditTime: 2020-08-25 10:09:44
 * @Description: app
 */
import {
  SET_COLLAPSED,
  SET_MOBILE,
  SET_PAD,
  SET_DRAWER,
  ADD_HISTORY_TAG,
  REMOVE_HISTORY_TAG,
  REMOVE_OTHER_TAG,
  REMOVE_ALL_TAG,
  CLEAR_ALL_TAG,
  SET_PLAYING,
  SET_PRIMAY_COLOR
} from "@/store/types";

const app = {
  state: {
    primaryColor: "#1890FF",
    isCollapsed: false,
    isMobile: false,
    isPad: false,
    showDrawer: false,
    historyTags: [],
    tags: [],
    formSize: "large",
    isPlaying: false
  },
  mutations: {
    [SET_COLLAPSED]: (state, payload) => {
      state.isCollapsed = payload;
    },
    [SET_MOBILE]: (state, payload) => {
      state.isMobile = payload;
    },
    [SET_PAD]: (state, payload) => {
      state.isPad = payload;
    },
    [SET_DRAWER]: (state, payload) => {
      state.showDrawer = payload;
    },
    [ADD_HISTORY_TAG]: (state, payload) => {
      state.historyTags.push(payload);
      state.tags.push(payload.name);
    },
    [REMOVE_HISTORY_TAG]: (state, payload) => {
      state.historyTags.splice(payload, 1);
      state.tags.splice(payload, 1);
    },
    [REMOVE_OTHER_TAG]: (state, payload) => {
      const historyTags = [state.historyTags[0]];
      const tags = [state.tags[0]];
      if (payload !== 0) {
        historyTags.push(state.historyTags[payload]);
        tags.push(state.tags[payload]);
      }
      state.historyTags = historyTags;
      state.tags = tags;
    },
    [REMOVE_ALL_TAG]: state => {
      state.historyTags = [state.historyTags[0]];
      state.tags = [state.tags[0]];
    },
    [CLEAR_ALL_TAG]: state => {
      state.historyTags = [];
      state.tags = [];
    },
    [SET_PLAYING]: (state, payload) => {
      state.isPlaying = payload;
    },
    [SET_PRIMAY_COLOR]: (state, payload) => {
      state.primaryColor = payload;
    }
  },
  actions: {
    addHistoryTag({ commit, state }, payload) {
      if (payload.name && payload.meta.title) {
        // 如果没有name 就说明没加过
        if (!state.tags.includes(payload.name)) {
          commit(ADD_HISTORY_TAG, payload);
        } else {
          // 有加过 有参数就更新
          const index = state.tags.findIndex(item => {
            return item === payload.name;
          });

          state.historyTags.splice(index, 1, payload);
          state.tags.splice(index, 1, payload.name);
        }
      }
    },
    rmoveHistoryTag({ commit }, payload) {
      commit(REMOVE_HISTORY_TAG, payload);
    },
    removeOtherTag({ commit }, payload) {
      commit(REMOVE_OTHER_TAG, payload);
    },
    removeAllTag({ commit }) {
      commit(REMOVE_ALL_TAG);
    }
  }
};

export default app;
